/* Pufa campaign layer v1.0 - dated gift campaigns (ShoppingIL, Black Friday, ...).
   Rows come from the `promotion` metaobject entries that carry gift_tiers, emitted by
   snippets/pufa-campaigns.liquid. Everything a shopper reads that contains a number is
   derived here from row.tiers, so the ribbon, strip, product badges and cart can
   never disagree. Switching on and off runs in the browser from the row's timestamps:
   Shopify caches rendered pages, so a Liquid date check would switch late.
   The cart itself is written only by pufa-gift-capsule.js (one cart writer, no races). */
(function (root) {
  'use strict';

  // ── Pure, exported for tests ──────────────────────────────────────────────
  // Amounts are agorot. Gaps round UP so "עוד ₪50" is always enough.
  function nis(agorot) { return '₪' + Math.ceil(agorot / 100); }

  function activeCampaign(rows, now) {
    for (var i = 0; i < (rows || []).length; i++) {
      if (now >= rows[i].start && now <= rows[i].end) return rows[i];
    }
    return null;
  }
  function lastEnded(rows, now) {
    var r = null;
    (rows || []).forEach(function (x) { if (x.end < now && (!r || x.end > r.end)) r = x; });
    return r;
  }
  function tierFor(row, total) {
    var r = null;
    row.tiers.forEach(function (t) { if (total >= t.at) r = t; });
    return r;
  }
  function nextTier(row, total) {
    for (var i = 0; i < row.tiers.length; i++) if (total < row.tiers[i].at) return row.tiers[i];
    return null;
  }
  // Milestones sit at equal steps on the bar whatever their prices are, and the fill is
  // scaled inside each step, so "half way to the next gift" always looks half way.
  function dotPct(i, n) { return (i + 1) / n * 100; }
  function fillPct(tiers, total) {
    var prev = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (total < tiers[i].at) return (i + (total - prev) / (tiers[i].at - prev)) / tiers.length * 100;
      prev = tiers[i].at;
    }
    return 100;
  }
  function giftQty(row, total) {
    var t = row ? tierFor(row, total) : null;
    return t ? t.gifts : 0;
  }
  function giftChange(have, want) { return have === want ? null : { quantity: want }; }

  function giftsLong(n) { return n === 1 ? 'קפסולת מתנה' : n + ' קפסולות מתנה'; }
  function giftsShort(n) { return n === 1 ? 'מתנה' : n + ' מתנות'; }

  // The ribbon's offer sentence. It names the first and the top tier with their own
  // thresholds, so the top number can never be read as the price of the first.
  function offerLine(row) {
    var T = row.tiers, top = T[T.length - 1];
    var line = '🎁 ' + (T[0].gifts === 1 ? 'קפסולה' : T[0].gifts + ' קפסולות') + ' עלינו מ-' + nis(T[0].at);
    return T.length === 1 ? line : line + ', ' + top.gifts + ' מ-' + nis(top.at);
  }
  // Shoppers hunt for a coupon code that does not exist. Its own span so CSS can drop it on the narrowest phones.
  var NO_CODE = ', בלי קוד';

  // Words above a day, a clock only in the last 24 hours. Hours are floored.
  function countdownText(ms) {
    if (ms <= 0) return '';
    var h = ms / 3600000;
    if (h >= 24) {
      var d = Math.floor(h / 24), r = Math.floor(h - d * 24);
      var days = d === 1 ? 'יום' : d === 2 ? 'יומיים' : d + ' ימים';
      var hours = r === 0 ? '' : r === 1 ? ' ושעה' : r === 2 ? ' ושעתיים' : ' ו-' + r + ' שעות';
      return 'רק עוד ' + days + hours;
    }
    var s = Math.floor(ms / 1000);
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return 'רק עוד ' + p(Math.floor(s / 3600)) + ':' + p(Math.floor(s % 3600 / 60)) + ':' + p(s % 60);
  }

  // freeShipAt is the standing free-pickup threshold. It is mentioned only when true.
  function cartMessage(row, total, freeShipAt, have) {
    var cur = tierFor(row, total), nx = nextTier(row, total);
    if (!cur) return { head: 'עוד ' + nis(nx.at - total) + ' ו' + giftsLong(nx.gifts) + ' עלינו 🎁', next: '' };
    var ship = total >= freeShipAt;
    var owed = typeof have === 'number' && have < cur.gifts
      ? (cur.gifts === 1 ? '🎁 מגיעה לך קפסולת מתנה' : '🎁 מגיעות לך ' + cur.gifts + ' קפסולות מתנה') : '';
    if (!nx) return { head: owed || '🥰 ' + giftsLong(cur.gifts) + ', מגיע לך', next: ship ? 'ומשלוח חינם לנקודת איסוף' : '' };
    return {
      head: owed || '🎁 ' + (cur.gifts === 1 ? 'מתנה אחת' : cur.gifts + ' מתנות') + ' בפנים!',
      next: 'עוד ' + nis(nx.at - total) + ' ויש לך ' + nx.gifts + ' מתנות' + (!ship && nx.at >= freeShipAt ? ' ומשלוח חינם לנקודת איסוף' : '')
    };
  }

  // fillers are sorted cheapest first by whoever fills the row.
  function pickFiller(row, total) {
    var nx = nextTier(row, total);
    if (!nx) return null;
    var need = nx.at - total, list = row.fillers || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].price >= need) return list[i];
    }
    return null;
  }

  var NEAR = 6000; // an option within 60 NIS of the next tier says so
  function sizeBadge(row, price) {
    var t = tierFor(row, price), n = nextTier(row, price);
    if (!t) return { text: 'עוד ' + nis(n.at - price) + ' למתנה 🎁', near: true, more: '' };
    return {
      text: '+ ' + giftsLong(t.gifts) + ' 🎁', near: false,
      more: n && n.at - price <= NEAR ? 'עוד ' + nis(n.at - price) + ' בעגלה = ' + giftsShort(n.gifts) : ''
    };
  }

  // Owner-entered data: keep only rows whose tiers are a usable, ascending list.
  function validRows(rows) {
    return (rows || []).filter(function (r) {
      return r && Array.isArray(r.tiers) && r.tiers.length > 0 &&
        r.tiers.every(function (t) { return t && typeof t.at === 'number' && typeof t.gifts === 'number' && t.at > 0 && t.gifts > 0; });
    }).map(function (r) {
      r.tiers = r.tiers.slice().sort(function (a, b) { return a.at - b.at; });
      return r;
    });
  }

  // A picker card sets the purchase price only when it selects a product variant. The picker
  // wrapper says so (data-mode="variant", snippets/dynamic-picker.liquid); without a wrapper, a
  // numeric data-variant-id on the card is the fallback.
  function selectsVariant(mode, variantId) {
    if (mode) return mode === 'variant';
    return /^\d+$/.test(String(variantId || ''));
  }

  // The text of the gold placeholder row shown where the removed campaign gifts were.
  function restoreLabel(owed) { return owed === 1 ? '🎁 קפסולת מתנה מחכה לך · להחזיר' : '🎁 ' + owed + ' קפסולות מתנה מחכות לך · להחזיר'; }

  // A referral gift card in the cart (state.blocked) withholds campaign gifts: no tier or gap UI then.
  function showsTierUi(state) { return !!state && !state.blocked; }

  var api = {
    showsTierUi: showsTierUi, nis: nis, activeCampaign: activeCampaign, lastEnded: lastEnded, tierFor: tierFor, nextTier: nextTier,
    giftQty: giftQty, giftChange: giftChange, giftsLong: giftsLong, giftsShort: giftsShort,
    offerLine: offerLine, NO_CODE: NO_CODE, countdownText: countdownText, cartMessage: cartMessage,
    pickFiller: pickFiller, sizeBadge: sizeBadge, validRows: validRows, selectsVariant: selectsVariant,
    restoreLabel: restoreLabel, dotPct: dotPct, fillPct: fillPct
  };
  root.PufaCampaign = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined') return; // Node test import stops here.

  // ── Config ────────────────────────────────────────────────────────────────
  var cfgEl = document.querySelector('script[data-pufa-campaigns]');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  CFG.rows = validRows(CFG.rows);
  var html = document.documentElement;
  var row = null, cartState = null, expiredChip = '', bootTimer = null, tick = null, ribEl = null;
  var gapBusy = false, gapTimer = null;

  // Draft themes only: the inline script in pufa-campaigns.liquid stored the ?campnow offset.
  function now() {
    var off = 0;
    if (CFG.preview) { try { off = parseInt(sessionStorage.getItem('pcl_off') || '0', 10) || 0; } catch (e) {} }
    return Date.now() + off;
  }
  // All text goes in through textContent: row strings come from the metaobject.
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }
  function removeAll(sel) { Array.prototype.forEach.call(document.querySelectorAll(sel), function (n) { n.remove(); }); }

  // ── Opt-out: the shopper removed the campaign gift with the X ─────────────
  var OPT_TTL = 24 * 60 * 60 * 1000;
  function optKey(id) { return 'pufa_camp_optout_' + id; }
  function optedOut(id) {
    try { var t = parseInt(localStorage.getItem(optKey(id)), 10); return !!t && Date.now() - t <= OPT_TTL; } catch (e) { return false; }
  }
  function setOptout(id, on) {
    try { on ? localStorage.setItem(optKey(id), String(Date.now())) : localStorage.removeItem(optKey(id)); } catch (e) {}
  }

  // ── S1 ribbon ─────────────────────────────────────────────────────────────
  // The fixed header (ss-header-17) already offsets itself by --countdown-bar-height.
  // The ribbon scrolls away with the page, so the offset shrinks as the page scrolls.
  // ownsOffset: the old coupon countdown bar writes --countdown-bar-height too. Only clear
  // what this script set, or a page with no campaign would wipe that bar's header offset.
  var ownsOffset = false;
  function headerOffset() {
    if (!ribEl) return;
    var h = ribEl.getBoundingClientRect().height;
    html.style.setProperty('--pcl-h', h + 'px');
    html.style.setProperty('--countdown-bar-height', Math.max(0, h - window.scrollY) + 'px');
    ownsOffset = true;
  }
  window.addEventListener('scroll', headerOffset, { passive: true });
  window.addEventListener('resize', headerOffset);

  function ribbon() {
    if (ribEl) { ribEl.remove(); ribEl = null; }
    clearInterval(tick);
    if (ownsOffset) {
      html.style.removeProperty('--pcl-h');
      html.style.removeProperty('--countdown-bar-height');
      ownsOffset = false;
    }
    if (!row) return;
    // A tap shows the tiers: the strip or the size badges when this page has them, the homepage otherwise.
    ribEl = el('a', 'pcl-rib');
    ribEl.href = '/';
    ribEl.addEventListener('click', function (e) {
      var to = document.querySelector('.pcl-strip, .pcl-badge');
      var detail = { campaign: row.id, to: to ? 'scroll' : 'home', page: location.pathname };
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'pufa_campaign_ribbon_tap' }, detail)); } catch (x) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', 'pufa_campaign_ribbon_tap', detail); } catch (x) {}
      if (!to) return;
      e.preventDefault();
      to.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    var offer = el('span', 'pcl-rib__offer', offerLine(row));
    offer.appendChild(el('span', 'pcl-rib__nocode', NO_CODE));
    ribEl.appendChild(offer);
    var meta = el('span', 'pcl-rib__meta');
    meta.appendChild(el('span', 'pcl-chip', row.chip));
    var cd = el('span', 'pcl-rib__cd');
    meta.appendChild(cd);
    ribEl.appendChild(meta);
    document.body.insertBefore(ribEl, document.body.firstChild);
    var paint = function () { cd.textContent = countdownText(row.end - now()); };
    paint();
    tick = setInterval(paint, 1000);
    headerOffset();
  }

  // ── Milestone track (S2 and S5). total === null draws the menu version. ───
  function track(total) {
    var T = row.tiers;
    var wrap = el('div', 'pcl-ms'), tr = el('div', 'pcl-ms__track');
    if (total) {
      var fill = el('div', 'pcl-ms__fill');
      fill.style.width = fillPct(T, total) + '%';
      tr.appendChild(fill);
    }
    T.forEach(function (t, i) {
      var on = total !== null && total >= t.at;
      var dot = el('span', 'pcl-ms__dot' + (on ? ' is-on' : ''), on ? '✓' : '🎁');
      dot.style.right = dotPct(i, T.length) + '%';
      var lab = el('span', 'pcl-ms__lab', giftsShort(t.gifts));
      lab.appendChild(el('small', '', 'מ-' + nis(t.at)));
      dot.appendChild(lab);
      tr.appendChild(dot);
    });
    wrap.appendChild(tr);
    return wrap;
  }

  // ── S2 strip (homepage only) ──────────────────────────────────────────────
  function home() {
    removeAll('.pcl-strip');
    if (!row) return;
    var btn = document.querySelector('[class*="hero-content-"] [class*="hero-button-"]');
    if (!btn) return;
    var strip = el('a', 'pcl-strip');
    strip.href = CFG.stripUrl;
    if (row.logo) strip.appendChild(el('div', 'pcl-strip__logo', row.logo));
    if (row.title) strip.appendChild(el('h2', 'pcl-strip__title', row.title));
    if (row.sub) strip.appendChild(el('p', '', row.sub));
    strip.appendChild(track(null));
    if (row.fine) strip.appendChild(el('p', 'pcl-strip__fine', row.fine));
    strip.appendChild(el('p', 'pcl-strip__ship', 'ומשלוח חינם לנקודת איסוף מ-' + nis(CFG.freeShipAt) + ', כמו תמיד'));
    strip.appendChild(el('span', 'pcl-strip__go', 'לבחירת ההפתעה שלי ←'));
    var section = btn.closest('.shopify-section');
    if (section) section.insertAdjacentElement('afterend', strip);
  }

  // ── S4 product option badges ──────────────────────────────────────────────
  // .iop-card__price must stay untouched: three readers parse its digits. The badge is a
  // sibling in the card body. Bundle rows carry their price in data-pay (agorot).
  function addBadge(host, price) {
    if (!host || !(price > 0)) return;
    var b = sizeBadge(row, price);
    host.appendChild(el('span', 'pcl-badge' + (b.near ? ' pcl-badge--near' : ''), b.text));
    if (b.more) host.appendChild(el('span', 'pcl-more', b.more));
  }
  function badges() {
    removeAll('.pcl-badge, .pcl-more, .pcl-note');
    if (!row) return;
    var cards = document.querySelectorAll('[data-iop-card]');
    var first = null;
    Array.prototype.forEach.call(cards, function (card) {
      var wrap = card.closest('[data-iop]');
      if (!selectsVariant(wrap && wrap.getAttribute('data-mode'), card.getAttribute('data-variant-id'))) return;
      var p = card.querySelector('.iop-card__price');
      if (!p) return;
      var c = p.cloneNode(true), s = c.querySelector('s');
      if (s) s.remove();
      var m = c.textContent.replace(/,/g, '').match(/\d+(\.\d+)?/);
      addBadge(card.querySelector('.iop-card__body'), m ? Math.round(parseFloat(m[0]) * 100) : 0);
      if (!first && card.querySelector('.pcl-badge')) first = card;
    });
    var rows = document.querySelectorAll('.pbb-row[data-pay]');
    Array.prototype.forEach.call(rows, function (r) {
      addBadge(r.querySelector('.pbb-row__meta') || r.querySelector('.pbb-row__content'), Number(r.getAttribute('data-pay')));
      if (!first && r.querySelector('.pcl-badge')) first = r;
    });
    if (first && first.parentNode) {
      first.parentNode.insertAdjacentElement('afterend', el('p', 'pcl-note', 'המתנות של ' + row.chip + ' נכנסות לעגלה לבד, בלי קוד'));
    }
  }

  // ── Sign-up pill: say that its gift is on top of the campaign's ───────────
  // Relabel only while the pill shows its default teaser (snippets/pufa-capsule-pick.liquid).
  // pufa-capsule-pick.js swaps in other texts, for example after a win, and those stay.
  var PILL_DEFAULT = 'קפסולה במתנה 🎁', PILL_CAMP = '🎁 עוד קפסולה בהרשמה';
  function pill() {
    var t = document.querySelector('[data-cp-teaser-text]');
    if (!t) return;
    var orig = t.getAttribute('data-pcl-orig'), root = t.closest('.pufa-cp') || t;
    if (row) {
      if (/\/cart\/?$/.test(location.pathname)) { root.setAttribute('data-pcl-collapsed', ''); return; }
      if (orig === null && t.textContent.trim() === PILL_DEFAULT) {
        t.setAttribute('data-pcl-orig', t.textContent);
        t.textContent = PILL_CAMP;
      }
      return;
    }
    root.removeAttribute('data-pcl-collapsed');
    if (orig !== null) {
      if (t.textContent === PILL_CAMP) t.textContent = orig;
      t.removeAttribute('data-pcl-orig');
    }
  }

  // ── S5 cart ───────────────────────────────────────────────────────────────
  // Section re-renders wipe injected nodes, so this runs again on every cart:refresh.
  function cartBar() {
    removeAll('.pcl-cart, .pcl-gap, .pcl-restore, .pcl-notice');
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-progress]'), function (p) {
      if (!row) {
        if (expiredChip) {
          p.insertAdjacentElement('beforebegin', el('div', 'pcl-notice', expiredChip + ' נגמר בחצות, אז מתנות המבצע יצאו מהעגלה. שאר ההזמנה מחכה לך כאן 🥰'));
        }
        return;
      }
      if (!showsTierUi(cartState)) return;
      var box = el('div', 'pcl-cart'), m = cartMessage(row, cartState.paid, CFG.freeShipAt, cartState.have);
      var msg = el('div', 'pcl-cart__msg', m.head);
      if (m.next) msg.appendChild(el('small', '', m.next));
      box.appendChild(msg);
      box.appendChild(track(cartState.paid));
      p.insertAdjacentElement('afterend', box);
      var last = box;
      if (cartState.want > 0 && cartState.have === 0 && optedOut(row.id)) {
        // "<what is waiting> · <action>": the action is drawn as a red button inside the row.
        var lab = restoreLabel(cartState.want - cartState.have).split(' · ');
        var r = el('button', 'pcl-restore', lab[0]);
        r.appendChild(el('span', 'pcl-restore__cta', lab[1]));
        r.type = 'button';
        last.insertAdjacentElement('afterend', r);
        last = r;
      }
      var f = pickFiller(row, cartState.paid);
      var nx = nextTier(row, cartState.paid);
      if (f && nx && !gapBusy) {
        var gap = el('div', 'pcl-gap'), t = el('span', 'pcl-gap__t', f.name + ' ב-' + nis(f.price));
        t.appendChild(el('small', '', 'ואז ' + giftsLong(nx.gifts) + ' עלינו'));
        var add = el('button', '', '+ הוספה');
        add.type = 'button';
        add.setAttribute('data-cart-upsell-add', ''); // handled by cart-upgrades.js
        add.setAttribute('data-variant-id', String(f.id));
        gap.appendChild(t);
        gap.appendChild(add);
        last.insertAdjacentElement('afterend', gap);
        last = gap;
      }
    });
  }
  document.addEventListener('cart:refresh', function () { setTimeout(cartBar, 80); });
  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('.pcl-restore');
    if (!r || !row) return;
    setOptout(row.id, false);
    if (root.PufaGift && root.PufaGift.recheck) root.PufaGift.recheck();
  });
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.pcl-gap button'))) return;
    gapBusy = true;
    clearTimeout(gapTimer);
    gapTimer = setTimeout(function () { gapBusy = false; cartBar(); }, 6000);
  });

  // ── Hooks for pufa-gift-capsule.js ────────────────────────────────────────
  api.giftVariant = CFG.giftVariant || 0;
  api.active = function () { return row; };
  api.optedOut = optedOut;
  api.setOptout = setOptout;
  api.cartPaid = function () { return showsTierUi(cartState) ? cartState.paid : null; };
  api.onCart = function (state) {
    var changed = !cartState || cartState.paid !== state.paid;
    if (changed) { gapBusy = false; clearTimeout(gapTimer); }
    cartState = state;
    cartBar();
    if (root.PufaUpsellOrder) root.PufaUpsellOrder(); // the carousel leads with the gap closer
  };
  api.onExpired = function () {
    var r = lastEnded(CFG.rows, now());
    expiredChip = r ? r.chip : '';
    cartBar();
  };

  // ── Boot, and switch on or off at the next window edge without a reload ───
  function boot() {
    var was = row;
    row = activeCampaign(CFG.rows, now());
    if (row) { html.setAttribute('data-camp', row.id); html.setAttribute('data-camp-skin', row.skin || 'gold'); }
    else { html.removeAttribute('data-camp'); html.removeAttribute('data-camp-skin'); }
    clearTimeout(bootTimer);
    var n = now(), edge = row ? row.end + 1000 : 0;
    if (!row) CFG.rows.forEach(function (r) { if (r.start > n && (!edge || r.start < edge)) edge = r.start; });
    // setTimeout overflows above ~24.8 days: cap it and re-evaluate then.
    if (edge) bootTimer = setTimeout(boot, Math.min(edge - n, 2147483000));
    [ribbon, home, badges, pill, cartBar].forEach(function (f) { try { f(); } catch (e) {} });
    if (was !== row && root.PufaGift && root.PufaGift.recheck) root.PufaGift.recheck();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(typeof window !== 'undefined' ? window : globalThis);